import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { SubscriptionBaseEffect } from './subscription-base.effect';

@NgModule({
  imports: [
    EffectsModule.forFeature([ SubscriptionBaseEffect ])
  ]
})
export class SubscriptionBaseModule {

}
